import React from 'react'
import { Link } from 'react-router-dom'

type Props = {
  //
}

// TODO: implement LIST here???
const LogoList: React.FC<Props> = () => (
  <ul className="list-unstyled CTAs">
    <li>
      <Link to="/">
        <img src="/assets/img/img-logo-list.png" alt="logolist" />
      </Link>
    </li>
  </ul>
)

export default LogoList
